import React, { createRef, RefObject, useEffect, useRef, useState } from "react";
import './ImageViewerStyle.css';
import { ThreeSixtySharp } from "@mui/icons-material";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch } from "../../store/hooks";
import { changeScrollEnabled } from "../../store/features/displaySlice";
import FitScreenOutlinedIcon from '@mui/icons-material/FitScreenOutlined';

export interface ImageViewerProps {
    imageUrls?: string[];
}

export const ImageViewer: React.FC<ImageViewerProps> = (props) => {
    const imageSource = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqF9Sx59vA1zH4lEWJCxZ4YQbGkr9GlDzkkQ&s";
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const scrollContainerBigImageRef = useRef<HTMLDivElement>(null);
    const scrollContainerSmallImagesModalRef = useRef<HTMLDivElement>(null);
    const imageModalContainerRef = useRef<HTMLDivElement>(null);
    const [selecImageRefs, setSelectImageRefs] = useState<RefObject<any>[]>([]);
    const [selecImageModalRefs, setSelectImageModalRefs] = useState<RefObject<any>[]>([]);
    const [selectSmallImageModalRefs, setSelectSmallImageModalRefs] = useState<RefObject<any>[]>([]);
    const [ largeImagePicRefs, setLargeImagePicRefs ] = useState<RefObject<any>[]>([]);
    const [isDragging, setIsDragging] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedIndexModal, setSelectedIndexModal] = useState(0);
    const [selectionMoved, setSelectionMoved] = useState(false);
    const [modalAlignStart, setModalAlignStart] = useState(false); 
    const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useAppDispatch();
    const imageListLength = 10;

    useEffect(() => {
        // add or remove refs
        setSelectImageRefs((elRefs) =>
          Array(props.imageUrls?.length)
            .fill(undefined)
            .map((_, i) => elRefs[i] || createRef()),
        );
        // add or remove refs
        setSelectImageModalRefs((elRefs) =>
            Array(props.imageUrls?.length)
              .fill(undefined)
              .map((_, i) => elRefs[i] || createRef()),
        );
        setSelectSmallImageModalRefs((elRefs) =>
            Array(props.imageUrls?.length)
                .fill(undefined)
                .map((_, i) => elRefs[i] || createRef()),
        );
        setLargeImagePicRefs((elRefs) =>
            Array(props.imageUrls?.length)
                .fill(undefined)
                .map((_, i) => elRefs[i] || createRef()),
        );
        if (selectSmallImageModalRefs[0]?.current?.getBoundingClientRect().left)
        {
            setModalAlignStart(selectSmallImageModalRefs[0]?.current?.getBoundingClientRect().left < 0);
        }
    }, [props.imageUrls]);

    useEffect(() => {
        dispatch(changeScrollEnabled(!modalOpen));
        if (modalOpen && imageModalContainerRef.current && scrollContainerSmallImagesModalRef.current) {
            handleSelectionImageClick(selectedIndex, imageModalContainerRef.current!, selecImageModalRefs, true);
            handleSelectionImageClick(selectedIndex, scrollContainerSmallImagesModalRef.current!, selectSmallImageModalRefs, true);
        }
    }, [modalOpen])

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>, container: HTMLDivElement) => {
        console.log('down')
        console.log(e.currentTarget);
        // const container = scrollContainerRef.current;
        if (!container) return;

        container.dataset.isDragging = "true";
        container.style.scrollSnapType = "none";
        container.dataset.startX = String(e.pageX);
        container.dataset.scrollLeft = String(container.scrollLeft);
        container.style.cursor = "grabbing";
        setIsDragging(true);
    };

    const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>, container: HTMLDivElement) => {
        // const container = scrollContainerRef.current;
        if (!container || container.dataset.isDragging !== "true") return;

        e.preventDefault();
        const startX = parseFloat(container.dataset.startX || "0");
        const scrollLeft = parseFloat(container.dataset.scrollLeft || "0");
        console.log("scrolling111112222222 " + scrollLeft)
        const walk = (e.pageX - startX) * 1; // Adjust scrolling speed
        const newScrollLeft = scrollLeft - walk;
        if (Math.abs(newScrollLeft - container.scrollLeft) >= 5) {
            setSelectionMoved(true);
        }
        container.scrollLeft = newScrollLeft;
    };

    let timer: any = null;

    const handleMouseUpOrLeave = (container: HTMLDivElement) => {
        // const container = scrollContainerRef.current;
        if (!container) return;

        // console.log("bounding rect left " + container.getBoundingClientRect().left)
        // console.log("bounding rect left2 " + selecImageRefs[0].current.getBoundingClientRect().left)
        container.style.scrollSnapType = "x mandatory";
        container.dataset.isDragging = "false";
        container.style.cursor = "grab";
        setIsDragging(false);
    };

    const handleContainerScroll = (container: HTMLDivElement, imageRefs: RefObject<any>[], isModal?: boolean) => {
        console.log("SCROLLING ", container.scrollLeft)
        clearTimeout(timer);
        // Renew timer
        timer = setTimeout(function () {
            // No scrolling event triggered. It is considered that
            // scrolling has stopped do what you want to do, such
            // as callback processing
            // console.log("dragging ", scrollContainerRef.current!.dataset.isDragging);
            // console.log("pic left ", selecImageRefs[1].current.getBoundingClientRect().left);

            if (container.dataset.isDragging == "false") {

                imageRefs.forEach((im, inx) => {
                    if (!imageRefs[inx].current || !container) return;
                    if (Math.abs(imageRefs[inx].current.getBoundingClientRect().left - container.getBoundingClientRect().left) < 10) {
                        console.log("HERE ARRIVE")
                        container.style.scrollBehavior = "auto";
                        container.style.scrollSnapType = "x mandatory";
                        container.dataset.isDragging = "false";
                        container.style.cursor = "grab";
                        setIsDragging(false);
                        if (!isModal) {
                            setSelectedIndex(inx);
                            handleSelectionImageClick(inx, scrollContainerBigImageRef.current!, largeImagePicRefs, true);
                        }
                        setSelectedIndexModal(inx);
                        if (isModal) {
                            handleSelectionImageClick(inx, imageModalContainerRef.current!, selecImageModalRefs, true);
                            handleSelectionImageClick(inx, scrollContainerSmallImagesModalRef.current!, selectSmallImageModalRefs, true);
                        }
                    }
                })
            }
        }, 100);
    }

    const selectPosModal = (index: number) => {
        console.log('next ', imageModalContainerRef.current, selecImageModalRefs)
        handleSelectionImageClick(index, imageModalContainerRef.current!, selecImageModalRefs);
        handleSelectionImageClick(index, scrollContainerSmallImagesModalRef.current!, selectSmallImageModalRefs);
    }

    const handleSelectionImageClick = (imgIndx: number, container: HTMLDivElement, imgRefs: RefObject<any>[], modal?: boolean) => {
        // scrolled amount + distance from left edge of screen - scroll container distance from left edge of screen = component left position in the scroll container, scroll amunt
        if (imgIndx != selectedIndex) {
            container.style.scrollSnapType = "none";
        }
        console.log("INDEXXXX", imgIndx, imgRefs[imgIndx].current.getBoundingClientRect().left);
        // maybe need to set isDragging to true to not trigger selecting all the images in between
        container.dataset.isDragging = "false";
        container.style.cursor = "grab";
        setIsDragging(false);
        if (modal) {
            setSelectedIndexModal(imgIndx);
        }
        const scrollVal = (container.scrollLeft + imgRefs[imgIndx].current.getBoundingClientRect().left) - container.getBoundingClientRect().left
        container.scroll({left: scrollVal, behavior: 'smooth'});
    }
    
    const handleImageModalClickOnArea = (targetClassNames?: any) => {
        if (targetClassNames && typeof targetClassNames == 'object') {
            if (targetClassNames.baseVal.includes('image-modal-content')) {
                return;
            }
        } else if (targetClassNames && typeof targetClassNames == 'string') {
            if (targetClassNames.includes('image-modal-content')) {
                return;
            }
        }
        console.log('close image modal');
        setModalOpen(false);
    }

    return (
        <div>
            <div className="relative w-full h-[400px] lg:h-[600px] flex flex-row items-center">
                <button className="absolute left-2 bg-gray-500 z-20" onClick={() => {
                    handleSelectionImageClick(Math.max(selectedIndex - 1, 0), scrollContainerBigImageRef.current!, largeImagePicRefs)
                    handleSelectionImageClick(Math.max(selectedIndex - 1, 0), scrollContainerRef.current!, selecImageRefs)
                }}>
                        <KeyboardArrowLeftIcon style={{width: '50px', height: '50px', color: 'white'}} /></button>
                <button className="absolute right-2 bg-gray-500 z-20" onClick={() => {
                    handleSelectionImageClick(Math.min(largeImagePicRefs.length - 1, selectedIndex + 1), scrollContainerBigImageRef.current!, largeImagePicRefs)
                    handleSelectionImageClick(Math.min(largeImagePicRefs.length - 1, selectedIndex + 1), scrollContainerRef.current!, selecImageRefs)
                }}>
                        <KeyboardArrowRight style={{width: '50px', height: '50px', color: 'white'}} /></button>
                <button className="absolute right-3 top-3 bg-gray-500 rounded-xl p-2 text-white text-sm hover:shadow-md transition-shadow duration-100 z-10" onClick={() => setModalOpen(true)}><FitScreenOutlinedIcon /> suurenda</button>
                <div className="absolute color-white top-2 left-2 z-20 font-bold text-white text-xl">{(selectedIndex + 1).toString()}/{largeImagePicRefs.length.toString()}</div>
                <div className="overflow-hidden w-full h-[400px] lg:h-[600px] scroll-smooth flex flex-row relative" 
                ref={scrollContainerBigImageRef}
                onScroll={() => handleContainerScroll(scrollContainerBigImageRef.current!, largeImagePicRefs)}>
                    {
                        props.imageUrls?.map((img, inx) => {
                            return <img ref={largeImagePicRefs[inx]} src={img} className="object-contain w-full flex-[0_0_100%] h-full rounded-xl" />
                        })
                    }
                    {/* <img src={imageSource} className="object-cover w-full flex-[0_0_100%] h-full rounded-md" /> */}
                </div>
            </div>
            <div
                className="overflow-x-scroll overflow-y-hidden w-full h-[150px] space-x-2 small-images-scroll-container flex flex-row box-border mt-1"
                ref={scrollContainerRef}
                onMouseDown={(e) => handleMouseDown(e, scrollContainerRef.current!)}
                onMouseMove={(e) => handleMouseMove(e, scrollContainerRef.current!)}
                onMouseUp={() => handleMouseUpOrLeave(scrollContainerRef.current!)}
                onMouseLeave={() => handleMouseUpOrLeave(scrollContainerRef.current!)}
                onClick={(e) => console.log('click')}
                onScroll={() => handleContainerScroll(scrollContainerRef.current!, selecImageRefs)}
                style={{ cursor: "grab" }} // Default grab cursor
            >
                {
                    props.imageUrls?.map((img, inx) => {
                        return <div className="w-[150px] flex-[0_0_auto]" onClick={() => {console.log('here click')}} onMouseUp={(e) => {if (!selectionMoved) {console.log('mouse down'); e.stopPropagation(); handleSelectionImageClick(inx, scrollContainerRef.current!, selecImageRefs); 
                        handleSelectionImageClick(inx, scrollContainerBigImageRef.current!, largeImagePicRefs)}; setSelectionMoved(false)}}>
                            <img src={img} ref={selecImageRefs[inx]} className={`snap-start box-border object-cover w-full h-[150px] rounded-md ${isDragging ? 'pointer-events-none' : 'pointer-events-auto'} ${selectedIndex == inx ? 'border-blue-400 border-[6px]' : 'border-none'}`} />
                        </div>
                    })
                }
            </div>
            { modalOpen &&
                <div className="fixed w-screen h-screen bg-opacity-80 bg-gray-600 flex justify-center z-50 top-0 left-0" onClick={(e) => handleImageModalClickOnArea((e.target as any).className)}>
                    <div className="w-full h-full flex flex-col justify-center items-center relative pt-0 lg:pt-[100px]">
                        <div className="absolute top-5 image-modal-content"><CloseIcon style={{width: '35px', height: '35px', color: 'white'}} 
                        className="image-modal-content cursor-pointer hover:fill-black" onClick={() => setModalOpen(false)}/></div>
                        <div className="absolute left-7 top-[350px] h-fit w-fit bg-white hover:bg-gray-400 cursor-pointer image-modal-content"
                        onClick={() => selectPosModal(Math.max(selectedIndexModal - 1, 0))}><KeyboardArrowLeftIcon style={{width: '40px', height: '40px', color: 'black'}} className="image-modal-content" /></div>
                        <div className="absolute right-7 top-[350px] h-fit w-fit bg-white hover:bg-gray-400 cursor-pointer image-modal-content"
                        onClick={() => selectPosModal(Math.min(selectedIndexModal + 1, props.imageUrls!.length - 1))}><KeyboardArrowRight style={{width: '40px', height: '40px', color: 'black'}} className="image-modal-content"/></div>
                        <div
                            className="w-full max-w-[1200px] overflow-x-scroll overflow-y-hidden h-[300px] lg:h-[600px] space-x-2 small-images-scroll-container flex flex-row box-border image-modal-content"
                            ref={imageModalContainerRef}
                            onMouseDown={(e) => handleMouseDown(e, imageModalContainerRef.current!)}
                            onMouseMove={(e) => handleMouseMove(e, imageModalContainerRef.current!)}
                            onMouseUp={() => handleMouseUpOrLeave(imageModalContainerRef.current!)}
                            onMouseLeave={() => handleMouseUpOrLeave(imageModalContainerRef.current!)}
                            onClick={(e) => console.log('click')}
                            onScroll={() => handleContainerScroll(imageModalContainerRef.current!, selecImageModalRefs, true)}
                            style={{ cursor: "grab" }} // Default grab cursor
                        >
                            {
                                props.imageUrls?.map((img, inx) => {
                                    return <div className="w-full h-[300px] lg:h-[600px] flex-[0_0_auto] image-modal-content" onClick={() => {console.log('here click')}} onMouseUp={(e) => {if (!selectionMoved) {console.log('mouse down'); e.stopPropagation(); handleSelectionImageClick(inx, imageModalContainerRef.current!, selecImageModalRefs)}; setSelectionMoved(false)}}>
                                        <img src={img} ref={selecImageModalRefs[inx]} className={`snap-start box-border object-contain w-full h-[300px] lg:h-[600px] rounded-md image-modal-content ${isDragging ? 'pointer-events-none' : 'pointer-events-auto'}`} />
                                    </div>
                                })
                            }
                        </div>
                        <div
                            className={`mt-[20px] lg:mt-[50px] w-full overflow-x-visible overflow-y-hidden h-[150px] lg:h-[150px] space-x-2 small-images-scroll-container flex flex-row box-border image-modal-content ${modalAlignStart ? "justify-start" : "justify-center"}`}
                            ref={scrollContainerSmallImagesModalRef}
                            onMouseDown={(e) => handleMouseDown(e, scrollContainerSmallImagesModalRef.current!)}
                            onMouseMove={(e) => handleMouseMove(e, scrollContainerSmallImagesModalRef.current!)}
                            onMouseUp={() => handleMouseUpOrLeave(scrollContainerSmallImagesModalRef.current!)}
                            onMouseLeave={() => handleMouseUpOrLeave(scrollContainerSmallImagesModalRef.current!)}
                            onClick={(e) => console.log('click')}
                            onScroll={() => handleContainerScroll(scrollContainerSmallImagesModalRef.current!, selectSmallImageModalRefs, true)}
                            style={{ cursor: "grab" }} // Default grab cursor
                        >
                            {
                                props.imageUrls?.map((img, inx) => {
                                    return <div className="w-[150px] h-[150px] lg:h-[150px] lg:w-[150px] flex-[0_0_auto] image-modal-content" onClick={() => {console.log('here click')}} onMouseUp={(e) => {if (!selectionMoved) {console.log('mouse down'); e.stopPropagation(); 
                                    handleSelectionImageClick(inx, scrollContainerSmallImagesModalRef.current!, selectSmallImageModalRefs, true)
                                    handleSelectionImageClick(inx, imageModalContainerRef.current!, selecImageModalRefs, true)
                                    }; setSelectionMoved(false)}}>
                                        <img src={img} ref={selectSmallImageModalRefs[inx]} className={`snap-start box-border object-cover w-full h-full rounded-md image-modal-content ${isDragging ? 'pointer-events-none' : 'pointer-events-auto'} ${selectedIndexModal == inx ? 'border-white border-4' : 'border-none'}`} />
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};
